/* eslint-disable @typescript-eslint/no-unsafe-call */

/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useTheme } from "styled-components";
import { useWindowSize } from "./useWindowSize"; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

var useCheckWindowSize = function useCheckWindowSize() {
  var highBreakpoint =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "mobile-1";
  var lowBreakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var [width] = useWindowSize();
  var theme = useTheme();
  var breakpointToCheck = highBreakpoint;
  var lowBreakpointToCheck = lowBreakpoint;

  if (typeof highBreakpoint === "string") {
    breakpointToCheck = theme.breakpoints[highBreakpoint.toLowerCase()] || 0;
  }

  if (typeof lowBreakpoint === "string") {
    lowBreakpointToCheck = theme.breakpoints[lowBreakpoint.toLowerCase()] || 0;
  }

  return breakpointToCheck > width && width > lowBreakpointToCheck;
};

export default useCheckWindowSize;
